module.exports = __webpack_public_path__ + "static/media/ScentBeautyLogo.efc32d96.png";